import clsx from 'clsx';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DrawerSkeleton from '../..';
import CommonCard from '../../../Components/General/CommonCard';
import DefineTime from '../../../Components/General/DefineTime';
import LabeledText from '../../../Components/General/LabeledText';
import ServicesAction from '../../../Components/General/ServicesAction';
import Button from '../../../Components/UI/Button';
import DateSelector from '../../../Components/UI/DateSelector';
import TimeSelectorCard from '../../../Components/UI/TimeSelectorCard';
import useAppointment from '../../../Features/useAppointment';
import useProfile from '../../../Features/useProfile';
import { formatPhoneNumber } from '../../../Helpers';
import { rescheduleAppointment } from '../../../Schema';
import { setSelectedService } from '../../../Store/serviceSlice';
import DrawerHeader from '../../DrawerHeader';
import CreateAndViewServicesDrawer from './CreateAndViewServicesDrawer';
import classes from './RescheduleAppointment.module.css';
import useDoctor from '../../../Features/useDoctor';
import { appointmentSorting } from '../../../Helpers';
const initialValues = {
  startTime: '',
  endTime: '',
  appointmentStartDateTime: '',
  appointmentEndDateTime: ''
};
const RescheduleAppointmentDrawer = ({ show, setShow, setShow2, data = null }) => {
  const {
    editAppointment,
    getAppointmentSlots,
    respectiveSlots,
    slotsIndicator,
    setSlotsIndicator,
    loading
  } = useAppointment();
  const dispatch = useDispatch();
  const selectedServices = useSelector((state) => state?.serviceReducer?.selectedServices);
  const { getDoctorTime } = useProfile();
  // const { getAllServicesListing } = useDoctor();
  const [selectedTime, setSelectedTime] = useState('');
  useEffect(() => {
    setValues({});
    if (show) {
      getDoctorTime();
      // getAllServicesListing();
    }
  }, []);
  const [showServiceDrawer, setShowServiceDrawer] = useState(false);
  const toggleServiceDrawer = () => {
    setShowServiceDrawer((currentState) => !currentState);
  };
  const formik = useFormik({
    initialValues,
    validationSchema: rescheduleAppointment,
    onSubmit: (values, { resetForm }) => {
      const params = {
        patientId: data?.patient?.patientId ? data?.patient?.patientId : data?.patientId,
        doctorClinicId: 0,
        appointmentId: data?.appointmentId ? data?.appointmentId : data?.appointmentID,
        isOpd: true,
        // appointmentStartDateTime: moment(values?.appointmentStartDateTime).utc().toISOString(),
        appointmentStartDateTime: moment(
          `${moment(values?.appointmentStartDateTime).format('YYYY-MM-DD')} ${
            selectedTime?.timeFrom
          }`,
          'YYYY-MM-DD hh:mm A'
        )
          .utc()
          .toISOString(),
        appointmentEndDateTime: moment(
          `${moment(values?.appointmentStartDateTime).format('YYYY-MM-DD')} ${
            selectedTime?.timeTo
          }`,
          'YYYY-MM-DD hh:mm A'
        )
          .utc()
          .toISOString(),
        appliedFees: values?.appliedFees
          ?.map((data) => data?.serviceId)
          ?.filter((data) => data != null)
      };

      editAppointment(params, () => {
        resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
        dispatch(setSelectedService([]));
        setSelectedTime('');
        setShow();
      });
    }
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    isValid,
    dirty
  } = formik;

  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  useEffect(() => {
    if (values?.appointmentStartDateTime) {
      getAppointmentSlots({
        date: moment(new Date(values?.appointmentStartDateTime)).format(
          'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
        ),
        timeZone: 'Asia/Karachi'
      });
    }
  }, [values?.appointmentStartDateTime]);
  const onToggle = () => {
    setSlotsIndicator('');
    resetForm();
    setShow();
  };

  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          dispatch(setSelectedService([]));
          onToggle();
        }}>
        <form onSubmit={handleSubmit} className={clsx(classes.wrapper, 'scrollbar1')}>
          <DrawerHeader
            title={'Reschedule Appointment'}
            setShow={() => {
              onToggle();
              setSelectedTime('');
            }}
            setShow2={() => {
              if (typeof setShow2 === 'function') {
                setShow2();
                setSelectedTime('');
              }
            }}
            onClose={() => {
              dispatch(setSelectedService([]));
              setSelectedTime('');
            }}
          />
          <div className={clsx(classes.wrapper, 'scrollbar1')}>
            <CommonCard>
              <h2 className={classes.cardHeading}>{data?.patientName}</h2>
              <div className={classes.shortDetail}>
                <LabeledText
                  label={'Phone Number'}
                  value={formatPhoneNumber(data?.countryCode + data?.cellNumber)}
                />
                <LabeledText label={'Age/Gender'} value={`${data?.age}, ${data?.gender}`} />
              </div>
            </CommonCard>

            <Row className={classes.controlGridWrapper}>
              <Col sm={6}>
                <DateSelector
                  className={classes.control}
                  setter={(e) => {
                    setSelectedTime(null);
                    handleChangeWithTouch('appointmentStartDateTime', e);
                  }}
                  value={values?.appointmentStartDateTime}
                  allowFutureDates={true} // Enable selecting future dates
                  placeholder="MM/dd/yyyy"
                  dateFormat="MM/dd/yyyy"
                  // minDate={decideAppointmentDate ? new Date() : new Date(selectedDate)}
                  minDate={new Date()}
                  startYear={1950}
                  endYear={9999} // Infinite years
                  showYearDropdown={true}
                  scrollableYearDropdown={true}
                  errorText={touched?.appointmentStartDateTime && errors?.appointmentStartDateTime}
                />
              </Col>
              <Col sm={6} className="mb-3 mt-sm-0 mt-3">
                <TimeSelectorCard
                  slots={respectiveSlots}
                  value={selectedTime}
                  setter={setSelectedTime}
                  disabled={values?.appointmentStartDateTime}
                />
              </Col>
            </Row>

            {slotsIndicator && <DefineTime />}
            <div className={classes.servicesActionWrapper}>
              <ServicesAction
                isDrawerOpen={showServiceDrawer}
                show={show}
                onClick={() => {
                  toggleServiceDrawer();
                  setShow();
                }}
              />
            </div>
          </div>
          <ul className={classes.bottomActionContainer}>
            <li>
              <Button
                onClick={() => {
                  if (typeof setShow === 'function') {
                    onToggle();
                    setSelectedTime('');
                    dispatch(setSelectedService([]));
                  }
                }}
                variants="cancel"
                label={'Close'}
                className={classes.cancelAction}
              />
            </li>
            <li>
              <Button
                variants="primary"
                type="submit"
                label={'Confirm'}
                disabled={
                  !(isValid && dirty && selectedServices?.length > 0 && selectedTime) || loading
                }
              />
            </li>
          </ul>
        </form>
      </DrawerSkeleton>
      <CreateAndViewServicesDrawer
        setShow2={setShow}
        show={showServiceDrawer}
        resetOfPrevDrawer={resetForm}
        setShow={toggleServiceDrawer}
      />
    </>
  );
};

export default RescheduleAppointmentDrawer;
